import React, { useState } from 'react';

const SafeTips = () => {
  const [showDetails, setShowDetails] = useState(false);

  const tips = [
    {
      tip: "Use fireworks outdoors only, away from buildings and flammable materials.",
      detail: "Choose a clear, open space at least 30 feet from structures, vehicles, or trees. Avoid dry grass or leaves to prevent unintended fires.",
      icon: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z",
      extraInfo: "Ensure the area is free of overhead obstructions like power lines."
    },
    {
      tip: "Keep a bucket of water or hose nearby to extinguish fires.",
      detail: "Have a fire extinguisher, a large bucket of water, or a connected garden hose ready. Quick access to water can prevent small sparks from becoming large fires.",
      icon: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z",
      extraInfo: "Test your water source before lighting fireworks to ensure it works."
    },
    {
      tip: "Never allow children to handle fireworks, including sparklers.",
      detail: "Sparklers can reach temperatures over 1,200°F, hot enough to cause third-degree burns. Always supervise children closely during firework displays.",
      icon: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z",
      extraInfo: "Teach children to stay at least 25 feet away from active fireworks."
    },
    {
      tip: "Soak used fireworks in water before disposal to prevent accidental ignition.",
      detail: "Submerge used fireworks in a bucket of water for at least 15 minutes. This prevents smoldering remnants from igniting trash or other materials.",
      icon: "M7 9v6H5V9h2zm12 0v6h-2V9h2zm-6 0v6h-2V9h2zm-3-7h6v2h-6zm6.67 12.33C17.45 15.11 18 16.28 18 17.5c0 2.49-2.01 4.5-4.5 4.5s-4.5-2.01-4.5-4.5c0-1.22.55-2.39 1.33-3.17L3 7h3v4h2V7h8v4h2V7h3z",
      extraInfo: "Use a metal container for disposal to avoid melting plastic bins."
    },
    {
      tip: "Keep pets indoors to reduce stress from loud noises.",
      detail: "Fireworks can cause severe anxiety in pets due to loud noises and bright lights. Create a quiet, safe space indoors with familiar bedding and toys.",
      icon: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
      extraInfo: "Consider playing calming music to mask firework sounds."
    },
    {
      tip: "Light one firework at a time and maintain a safe distance.",
      detail: "Light fireworks on a flat, stable surface and stand at least 25 feet away after lighting. Never attempt to relight or handle malfunctioning fireworks.",
      icon: "M12 2l-1.5 6h-5l4 4-1.5 6 5-3.5 5 3.5-1.5-6 4-4h-5z",
      extraInfo: "Wait at least 20 minutes before approaching duds, then soak them in water."
    },
  ];

  return (
    <div className="bg-gradient-to-b from-orange-50 to-yellow-50 text-gray-800 font-sans min-h-screen">
      <section id="safe-tips" className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-orange-600 mb-8 text-center font-serif animate-slide-in-top">
          Fireworks Safety Tips
        </h2>
        <p className="text-center text-lg sm:text-xl text-gray-600 mb-10 animate-fade-in">
          Follow these essential guidelines to ensure a safe and enjoyable fireworks experience.
        </p>
        <div className="flex justify-center mb-8">
          <button
            onClick={() => setShowDetails(!showDetails)}
            className="px-6 py-3 bg-orange-600 text-white rounded-full hover:bg-orange-700 transition duration-300 text-base sm:text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1"
          >
            {showDetails ? 'Hide Details' : 'Show More Details'}
          </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {tips.map((item, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-lg flex items-start space-x-4 transform transition-all duration-500 hover:scale-105 animate-slide-in"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <svg className="w-8 h-8 text-orange-600 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                <path d={item.icon} />
              </svg>
              <div>
                <p className="text-base sm:text-lg text-gray-800 font-semibold">{item.tip}</p>
                {showDetails && (
                  <div className="mt-2 animate-fade-in">
                    <p className="text-sm sm:text-base text-gray-600">{item.detail}</p>
                    <p className="text-xs sm:text-sm text-gray-500 italic mt-1">{item.extraInfo}</p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default SafeTips;

